import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../atoms/LanguageSwitcher.js';

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const { t } = useTranslation();

  const navItems = [{ label: t('nav.survey_list'), href: '/dashboard' }];

  return (
    <div className="flex min-h-screen bg-neutral-50">
      {/* Sidebar */}
      <aside className="hidden w-60 shrink-0 border-r border-neutral-200 bg-white md:block">
        <div className="flex h-14 items-center border-b border-neutral-200 px-4">
          <span className="text-lg font-bold text-primary-700">PulseAgent</span>
        </div>
        <nav className="mt-2 flex flex-col gap-1 px-2">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-lg px-3 py-2 text-sm font-medium text-neutral-600 transition-colors hover:bg-neutral-100 hover:text-neutral-900"
            >
              {item.label}
            </a>
          ))}
        </nav>
      </aside>

      {/* Main area */}
      <div className="flex flex-1 flex-col">
        {/* Top bar */}
        <header className="flex h-14 items-center justify-between border-b border-neutral-200 bg-white px-6">
          <div className="md:hidden">
            <span className="text-lg font-bold text-primary-700">PulseAgent</span>
          </div>
          <div className="ml-auto">
            <LanguageSwitcher />
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  );
}
